export const filterDocuments = ({documents, search, type = ''}) => {

  const template = Array.from(search.toLowerCase()).reduce(
    (acc, val, i) => `${acc}[^${search.substr(i)}]*?${val === `+` ? `.` : val}`,
    '',
  );

  const reg = new RegExp(template);
  if (search.length < 1) {
    return documents;
  };

  if(type === 'name') {
    return documents.filter((doc) => doc.name.toLowerCase().match(reg));
  };
  
  if(type === 'fullName') {
    return documents.filter((doc) => doc.email.toLowerCase().match(reg) || doc.firstName.toLowerCase().match(reg) || doc.lastName.toLowerCase().match(reg) || doc.email.toLowerCase().match(reg));
  };
};
